<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Basic Form</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Route vehicle map</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <table style="border: 1px solid lightgray;">
      <tr style="background: #97cdef;    font-size: 16px;">
        <th>Route</th>
        <th>Morning (Tray count in nos)</th>
        <th>Evening</th>
      </tr>
      <tr *ngFor="let route of route_list">
        <td>{{route}}</td>
        <td (click)="openDialog(vehicle_map[route]['mor_route_id'], vehicle_map[route]['mor_vehicle_id'])"
          style="cursor: pointer;">
          {{vehicle_map[route]['mor_vehicle_name']}} - ({{vehicle_map[route]['mor_vehicle_tray_capacity']}} nos) <span
            style="font-size: 16px;" class="material-icons">
            create
          </span></td>
        <td (click)="openDialog(vehicle_map[route]['eve_route_id'], vehicle_map[route]['eve_vehicle_id'])"
          style="cursor: pointer;">
          {{vehicle_map[route]['eve_vehicle_name']}} - ({{vehicle_map[route]['eve_vehicle_tray_capacity']}} nos) <span
            style="font-size: 16px;" class="material-icons">
            create
          </span></td>
      </tr>
    </table>
  </div>
</section>
